import styled from '@emotion/styled';
import { css, Theme } from '@emotion/react';
import { animations, colors, text } from '../../core/styles/theme/default';

const LinkStyles = ({ theme }: { theme?: Theme }) => css`
  a {
    color: currentColor;
    transition: color ${animations.default};

    &:active,
    &:visited {
      color: ${colors.primary800};
    }

    &:hover {
      color: ${colors.primary};
    }

    &:focus {
      color: ${colors.primary};
    }

    & {
      ${theme?.stylesExtension?.typography?.linkStyles}
    }
  }
`;

const T1 = styled.p`
  ${text.t1};
  color: ${colors.white};
`;

const T2 = styled.p`
  ${text.t2};
  color: ${colors.white};
`;

const H1 = styled.h1`
  ${text.h1};
  ${({ theme }) => theme?.stylesExtension?.typography?.h1}
`;

const H2 = styled.h2`
  ${text.h2};
  ${({ theme }) => theme?.stylesExtension?.typography?.h2}
`;

const H3 = styled.h3`
  ${text.h3};
  ${({ theme }) => theme?.stylesExtension?.typography?.h3}
`;

const H4 = styled.h4`
  ${text.h4};
`;

const H5 = styled.h5`
  ${text.h5};
`;

const H6 = styled.h6`
  ${text.h6};
`;

const P1 = styled.p`
  ${text.p1};
  ${LinkStyles};
`;

const P2 = styled.p`
  ${text.p2};
  ${LinkStyles};
`;

const P3 = styled.p`
  ${text.p3};
  ${LinkStyles};
`;

const P4 = styled.p`
  ${text.p4};
  ${LinkStyles};
`;

const L1 = styled.label`
  ${text.l1};
`;

const LEAD1 = styled.p`
  ${text.lead1};
`;

const UL = styled.ul`
  padding: 0 0 0 1rem;
  margin: 0;
  list-style: none;

  li {
    + li {
      margin-top: 16px;
    }

    &::before {
      content: '•';
      color: ${colors.blue800};
      display: inline-block;
      width: 1rem;
      margin-left: -1rem;
    }
  }
`;

export { T1, T2, H1, H2, H3, H4, H5, H6, P1, P2, P3, P4, L1, LEAD1, UL };
